import { FC } from 'react';

import { Box, Skeleton, useTheme } from '@mui/material';

import { CourseDiscussionItemType } from '../courseDiscussionBox/courseDiscussionItem';
import { DiscussionItemStyle } from '../courseDiscussionBox/courseDiscussionItem/style';

const CourseDiscussionItemSkeleton: FC = () => {
  const theme = useTheme();

  return (
    <DiscussionItemStyle type={CourseDiscussionItemType.LIST_ITEM} sx={{ borderColor: theme.palette.divider }}>
      <Box width={40} minWidth={40} height={40} borderRadius="100%" overflow="hidden">
        <Skeleton animation="wave" variant="rectangular" width={40} height={40} sx={{ borderRadius: 2 }} />
      </Box>
      <Skeleton
        animation="wave"
        variant="rectangular"
        height={122}
        sx={{ padding: '8px 16px 8px 16px', borderRadius: '9px', flex: '1', marginLeft: 1 }}
      />
    </DiscussionItemStyle>
  );
};

const CourseDiscussionContentSkeleton: FC = () => {
  return (
    <>
      <CourseDiscussionItemSkeleton />
      <CourseDiscussionItemSkeleton />
      <CourseDiscussionItemSkeleton />
    </>
  );
};

export default CourseDiscussionContentSkeleton;
